import { render, staticRenderFns } from "./import-buying-prices.vue?vue&type=template&id=331b4fb0"
import script from "./import-buying-prices.vue?vue&type=script&lang=js"
export * from "./import-buying-prices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports